import Component from '../core/Component'
import MarketFormFileItem from './MarketFormFileItem'
import Dropzone from 'dropzone'
Dropzone.autoDiscover = false
import substitute from '../utils/substitute'

export const STATUS = {
    FILES: 'has-files'
}

export default class FeedbackForm extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            files: null,
            list: null,
            fileButton: null,
            template: null
        }
    }

    prepare() {
        this.dropzone = new Dropzone(this.element, {
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 10,
            maxFiles: 100,
            addRemoveLinks: true,
            previewsContainer: null,
            createImageThumbnails: false,
            clickable: this.ref.fileButton,
            addedfile: ::this.handleFileAdded,
            removedfile: ::this.handleFileRemoved,
            success: ::this.handleSuccess
        })

        this.template = this.ref.template ? this.ref.template.innerText : ''

        this.element.addEventListener('submit', ::this.handleSubmit)
        this.element.addEventListener('reset', ::this.handleReset)

        this.check()

    }

    handleSubmit(event) {
        event.preventDefault()
        const form = event.currentTarget
        if (this.dropzone.getQueuedFiles().length) {
            this.dropzone.processQueue()
        } else {
            $.nette.ajax({
                url: this.element.action,
                method: this.element.method,
                beforeSend: function() {
                    form.classList.add('is-loading')
                },
                complete: function () {
                    form.classList.remove('is-loading')
                },
                data: $(this.element).serialize()
            })
        }
    }

    handleReset() {
        this.dropzone.removeAllFiles()
    }

    handleFileRemoved() {
        this.check()
    }

    handleFileAdded(file) {
        const buffer = document.createElement('div')
        buffer.innerHTML = substitute(this.template, file)

        const item = buffer.querySelector('[data-ref="item"]')

        const removeButton = item.querySelector('[data-ref="remove"]')
        removeButton.addEventListener('click', event => {
            event.preventDefault()
            this.handleRemove(item, file)
        })

        this.ref.list.appendChild(item)
        this.check()
    }

    handleRemove(item, file) {
        this.dropzone.removeFile(file)
        item.parentNode.removeChild(item)
    }

    handleSuccess(file, response) {
        const snippets = $.nette.ext('snippets')
        if (snippets) {
            snippets.updateSnippets(response.snippets, response.append, null, response)
        }
        if (response && response.redirect) {
            window.location = response.redirect
        }
    }

    check() {
        this.ref.files && this.ref.files.classList.toggle(STATUS.FILES, !!this.dropzone.files.length)
    }
}